<template>
  <v-container class="pa-0" fluid>
    <v-container class="header" fluid>
      <v-layout column align-center justify-center>
        <v-col xl="12" lg="12" md="12" sm="12" class="pb-0">
          <v-layout align-center style="height: 130px">
            <v-layout row style="position: absolute">
              <v-img
                @click="goBack()"
                height="45"
                width="45"
                class="shrink pointer"
                contain
                :src="require('../../assets/back.png')"
              />
              <div class="ml-3" style="color: #fff; width: 96px">Back to profuse.md</div>
            </v-layout>
            <v-col xl="8" lg="9" md="12" sm="12" class="pb-0 mx-auto">
              <Toolbar />
            </v-col>
          </v-layout>
        </v-col>

        <v-col xl="8" lg="10" md="10" sm="12">
          <v-col md="6" sm="12">
            <div class="app-title">Signature Stamp</div>
            <div
              class="app-description"
            >We specialize in native, mobile and web applications development, as well as developing strong and scalable back-end systems to support the projects.</div>

            <v-row class="mt-9 pt-5">
              <v-flex shrink mr-9 mb-5 class="pointer">
                <v-img
                  @click="openAppStore"
                  height="58"
                  width="165"
                  contain
                  :src="require('../../assets/app_store.png')"
                />
              </v-flex>
            </v-row>
          </v-col>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="content" fluid>
      <v-layout align-center justify-center>
        <v-col xl="8" lg="10" md="10" sm="12">
          <v-layout justify-center>
            <v-col xl="8" lg="8" md="10" sm="12">
              <div
                v-resize-text="{ratio:0.9, maxFontSize: '50px'}"
                class="content-title"
              >Get your pen-signature in digital format and apply it on any digital document.</div>
              <div class="how-it-works">How it works:</div>
            </v-col>
          </v-layout>

          <v-layout row justify-center>
            <v-col cols="10" md="3" sm="6">
              <v-layout column align-center>
                <v-img
                  height="71"
                  width="71"
                  contain
                  :src="require('../../assets/signature/elipse_1.png')"
                />
                <div
                  class="item-description mt-9"
                >Take a picture of your signature on a clean, white paper</div>
              </v-layout>
            </v-col>

            <v-col cols="10" md="3" sm="6">
              <v-layout column align-center>
                <v-img
                  height="71"
                  width="71"
                  contain
                  :src="require('../../assets/signature/elipse_2.png')"
                />
                <div
                  class="item-description mt-9"
                >The app's AI model will process the image, remove the background and leave only the signature on a transparent background.</div>
              </v-layout>
            </v-col>

            <v-col cols="10" md="3" sm="6">
              <v-layout column align-center>
                <v-img
                  height="71"
                  width="71"
                  contain
                  :src="require('../../assets/signature/elipse_3.png')"
                />
                <div
                  class="item-description mt-9"
                >Sign any document straight away with this signature or save it for later use ... or share it :)</div>
              </v-layout>
            </v-col>

            <v-col class="mt-9" cols="10" md="8" sm="10">
              <v-img contain :src="require('../../assets/signature/screenshot.png')" />
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="features" fluid>
      <v-layout column align-center>
        <v-col xl="8" lg="10" md="10" sm="12">
          <div class="features-title">App Features</div>
          <div
            class="features-description"
          >Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece</div>
        </v-col>

        <v-col cols="12" lg="8" md="10">
          <v-layout row justify-center>
            <v-col cols="10" md="4" class="features-item">
              <v-img height="70" contain :src="require('../../assets/signature/union.png')" />
              <div
                class="feature-item-text"
              >Scan signature on the spot or use a picture from your photo library</div>
            </v-col>

            <v-col cols="10" md="4" class="features-item">
              <v-img height="70" contain :src="require('../../assets/signature/mop.png')" />
              <div
                class="feature-item-text"
              >Scan signature on the spot or use a picture from your photo library</div>
            </v-col>

            <v-col cols="10" md="4" class="features-item">
              <v-img height="70" contain :src="require('../../assets/signature/signature.png')" />
              <div
                class="feature-item-text"
              >Scan signature on the spot or use a picture from your photo library</div>
            </v-col>

            <v-col cols="10" md="4" class="features-item">
              <v-img height="70" contain :src="require('../../assets/signature/signature.png')" />
              <div
                class="feature-item-text"
              >Scan signature on the spot or use a picture from your photo library</div>
            </v-col>

            <v-col cols="10" md="4" class="features-item">
              <v-img height="70" contain :src="require('../../assets/signature/share.png')" />
              <div
                class="feature-item-text"
              >Scan signature on the spot or use a picture from your photo library</div>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="reviews" fluid>
      <v-layout justify-center>
        <v-col cols="12" xl="8" lg="8" md="10" class="pa-0">
          <v-layout justify-center>
            <div class="user-reviews">User Reviews</div>
          </v-layout>

          <v-carousel height="380px" cycle hide-delimiters>
            <v-carousel-item v-for="(review, i) in reviews" :key="i">
              <v-sheet color="transparent" height="100%">
                <v-row class="fill-height">
                  <v-layout justify-center column align-center>
                    <v-col cols="10" md="8" sm="8">
                      <div class="review-text">{{ review.text }} Slide</div>
                      <v-layout justify-center>
                        <v-rating class="mt-9" readonly color="#4c49f3" v-model="review.rating" />
                      </v-layout>
                      <div class="review-author">{{ review.author }}</div>
                    </v-col>
                  </v-layout>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="socials" fluid>
      <v-col xl="4" lg="6" sm="12" class="mx-auto">
        <v-row>
          <v-col md="6" sm="6">
            <v-layout justify-center align-center>
              <v-flex shrink>
                <v-img height="44" contain :src="require('../../assets/signature/facebook.png')" />
              </v-flex>
              <div class="social-text">Facebook</div>
            </v-layout>
          </v-col>

          <v-col md="6" sm="6">
            <v-layout justify-center align-center>
              <v-flex shrink>
                <v-img height="44" contain :src="require('../../assets/signature/instagram.png')" />
              </v-flex>
              <div class="social-text">Instagram</div>
            </v-layout>
          </v-col>
        </v-row>
      </v-col>
    </v-container>

    <v-container class="video" fluid>
      <video-player ref="videoPlayer" :options="playerOptions"></video-player>
    </v-container>

    <v-container class="download" fluid>
      <v-col xl="6" lg="10" sm="12" class="mx-auto">
        <div class="download-title">Download now</div>
        <v-row>
          <v-col md="6" sm="10" class="mx-auto">
            <v-img contain :src="require('../../assets/signature/download_screenshot.png')" />
          </v-col>

          <v-col md="6" sm="10" align-self="center" class="mx-auto">
            <v-img
              class="mb-9"
              height="103"
              width="91"
              contain
              :src="require('../../assets/signature/like.png')"
            />
            <div class="download-description">
              This app creates your
              REAL / HANDWRITTEN signature, NOT some finger-painting stuff that the rest of the apps offer, that often looks like made by a
              4 years old :)
            </div>

            <v-row>
              <v-col cols="10" md="4">
                <v-img
                  @click="openAppStore"
                  class="pointer"
                  height="58"
                  width="165"
                  contain
                  :src="require('../../assets/app_store.png')"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-container>

    <v-container class="footer" fluid>
      <v-layout>
        <v-layout class="shrink mx-auto mt-9 mb-9">
          <div class="copyright">Copyright @ 2020 . All rights reserved</div>
          <div class="ml-4 mr-4">|</div>
          <div class="contact-us">Contact us</div>
        </v-layout>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Toolbar from "./components/Toolbar";

export default {
  components: {
    Toolbar
  },
  data() {
    return {
      rating: 0,
      reviews: [
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 4,
          author: "Amanda Dolington"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 2,
          author: "Cris Dolington"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 5,
          author: "John Doe"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 1,
          author: "Alison"
        },
        {
          text:
            "Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          rating: 3,
          author: "Jess"
        }
      ],
      playerOptions: {
        loop: true,
        autoplay: true,
        controls: false,
        fluid: true,
        muted: true,
        language: "en",
        sources: [
          {
            type: "video/mp4",
            src:
              "https://1192292578.rsc.cdn77.org/sites/profuse2020/signature_stamp.mp4"
          }
        ],
        poster:
          "https://1192292578.rsc.cdn77.org/sites/profuse2020/scanner_preview.png"
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openAppStore() {
      window.open("https://apps.apple.com/us/app/signature-stamp/id1502608223", '_blank');
    },
  }
};
</script>

<style scoped>
.header {
  background-image: url("../../assets/signature/header_bg.png");
  background-size: cover;
  background-position: top left 35%;
  min-height: 1000px;
  flex-direction: column;
}
.app-title {
  font-family: "Montserrat";
  font-size: 40px;
  font-weight: 500;
  line-height: 1.23;
  text-align: left;
  color: #fafafa;
  margin-top: 20vh;
}
.app-description {
  font-family: "Montserrat";
  font-size: 28px;
  font-weight: 300;
  line-height: 1.21;
  text-align: left;
  color: #fafafa;
  margin-top: 45px;
}
.pointer {
  cursor: pointer;
}
.content-title {
  font-family: "Montserrat";
  font-size: 50px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #4c49f3;
}
.content {
  background-image: url("../../assets/signature/content_bg.png");
  background-size: cover;
  background-position: center;
}
.how-it-works {
  font-family: "Montserrat";
  font-size: 40px;
  line-height: 1.23;
  text-align: center;
  color: #000000;
  margin-top: 138px;
}
.item-description {
  font-family: "Montserrat";
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  color: #575757;
}
.features-title {
  font-family: "Montserrat";
  font-size: 40px;
  line-height: 1.23;
  text-align: center;
  color: #000000;
  margin-top: 30px;
}
.features-description {
  font-family: "Montserrat";
  font-size: 28px;
  line-height: 1.14;
  text-align: center;
  color: #575757;
  margin-top: 38px;
  margin-bottom: 30px;
}
.features-item {
  max-width: 320px;
  margin-top: 70px;
}
.feature-item-text {
  font-family: "Montserrat";
  font-size: 20px;
  line-height: 1.3;
  text-align: center;
  color: #575757;
  margin-top: 22px;
}
.reviews {
  background-image: url("../../assets/signature/content_bg.png");
  background-size: cover;
}
.user-reviews {
  font-family: "Montserrat";
  font-size: 40px;
  line-height: 1.23;
  text-align: left;
  color: #000000;
  margin-top: 50px;
}
.review-text {
  font-family: "Montserrat";
  font-size: 28px;
  line-height: 1.14;
  text-align: center;
  color: #575757;
}
.review-author {
  font-family: "Montserrat";
  font-size: 28px;
  font-style: italic;
  line-height: 1.21;
  text-align: center;
  color: #000000;
}
.social-text {
  font-family: "Montserrat";
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #4c49f3;
}
.video {
  padding: 0px;
}
.download {
  background-image: url("../../assets/signature/download_background.png");
  background-size: cover;
}
.download-title {
  font-family: "Montserrat";
  font-size: 40px;
  line-height: 1.23;
  text-align: center;
  color: #000000;
  margin-bottom: 120px;
  margin-top: 50px;
}
.download-description {
  font-family: "Montserrat";
  font-size: 28px;
  line-height: 1.43;
  text-align: left;
  color: #575757;
}
.copyright {
  font-family: "Montserrat";
  font-size: 18px;
  line-height: 1.22;
  text-align: center;
  color: #000000;
}
.contact-us {
  font-family: "Montserrat";
  font-size: 18px;
  line-height: 1.22;
  text-align: center;
  color: #000000;
}
</style>